import { useCallback, useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router";

import Loading from "../components/Loading";
import Menu from "../components/Menu";

import { DialogTear } from "../components/Manutencao/DialogTear";
import { DialogHistorico } from "../components/Manutencao/DialogHistorico";
import { DialogOleo } from "../components/Manutencao/DialogOleo";
import { DialogFita } from "../components/Manutencao/DialogFita";
import { DialogRoda } from "../components/Manutencao/DialogRoda";
import { TearExpansionTemplate } from "../components/Manutencao/TearExpansionTemplate";

import api from "../services/api";

const initialState = {
    grupo: "", tear: "", modelo: "", serial: "",
    pos_x: "", pos_y: "", passadas_tear: "", data_aquisicao: new Date()
};

const initialFormHistoryState = {
    id: null, colaborador_id: "", data: new Date(), descricao: "",
    tear: "", manutencao_tipo_id: "", turma_id: "",
    oleo_id: null, fitas_id: null, rodas_id: null, passadas: null,
};

export function Sala() {
    const navigate = useNavigate();
    const toast = useRef();

    const [data, setData]               = useState([]);
    const [colaboradores, setColaboradores] = useState([]);
    const [tipos, setTipos]             = useState([]);
    const [turmas, setTurmas]           = useState([]);
    const [oleos, setOleos]             = useState([]);
    const [config, setConfig]           = useState({ teares: 72, grupos: 5 });
    const [historicoOleosGeral, setHistoricoOleosGeral] = useState([]);
    const [historicoFitasGeral, setHistoricoFitasGeral] = useState([]); 
    const [historicoRodasGeral, setHistoricoRodasGeral] = useState([]);

    const [listaOleos, setListaOleos] = useState([]);
    const [oleo, setOleo]             = useState({ id: null, nome: '', validade: null });

    const [listaFitas, setListaFitas] = useState([]);
    const [fita, setFita]             = useState({ id: null, nr_serie: '', validade: null, passadas_programadas: null });

    const [listaRodas, setListaRodas] = useState([]);
    const [roda, setRoda]             = useState({ id: null, nr_serie: '', validade: null, passadas_programadas: null });

    const [isEditing, setIsEditing]               = useState(false);
    const [isLoading, setIsLoading]               = useState(false);
    const [isVisible, setIsVisible]               = useState(false);
    const [isVisibleHistory, setIsVisibleHistory] = useState(false);
    const [isVisibleOleo, setIsVisibleOleo]       = useState(false);
    const [isVisibleOleoCE, setIsVisibleOleoCE]   = useState(false);
    const [isVisibleFita, setIsVisibleFita]       = useState(false);
    const [isVisibleFitaCE, setIsVisibleFitaCE]   = useState(false);
    const [isVisibleRoda, setIsVisibleRoda]       = useState(false);
    const [isVisibleRodaCE, setIsVisibleRodaCE]   = useState(false);
    const [expandedRows, setExpandedRows]         = useState(null);

    const [formData, setFormData]       = useState({ ...initialState });
    const [formHistory, setFormHistory] = useState({ ...initialFormHistoryState });

    const showError = (error) => {
        toast.current.show({
            summary: 'Ocorreu um Erro', severity: 'error',
            detail: error.response ? error.response.data.message : error.message
        });
    };

    const showSuccess = (response) => {
        const msg = typeof response === 'string' ? response : response.data.message;
        toast.current.show({ summary: 'Sucesso', severity: 'success', detail: msg });
    };

    const showValidation = (mensagem) => {
        toast.current.show({ severity: 'error', summary: 'Atenção', detail: mensagem, life: 4000 });
    };

    const verificarStatusOleo = (rowData) => {
        if (!rowData.oleo_id) return 'normal';
        const oleoVinculado = oleos.find(o => o.id === rowData.oleo_id);
        if (!oleoVinculado?.validade) return 'normal';

        const dataVencimento = new Date(String(rowData.data).replace(/-/g, "/"));
        dataVencimento.setFullYear(dataVencimento.getFullYear() + parseInt(oleoVinculado.validade));
        const dataAlerta = new Date(dataVencimento);
        dataAlerta.setMonth(dataAlerta.getMonth() - 3);
        const hoje = new Date();

        if (hoje >= dataVencimento) return 'vencido';
        if (hoje >= dataAlerta) return 'alerta';
        return 'normal';
    };

    const verificarStatusFitaRoda = (rowData, lista, idField, passadasAtuais) => {
        if (!rowData[idField]) return 'normal';
        const item = lista.find(i => i.id === rowData[idField]);
        if (!item) return 'normal';

        let statusData = 'normal';
        if (item.validade) {
            const dataVenc = new Date(String(rowData.data).replace(/-/g, "/"));
            dataVenc.setFullYear(dataVenc.getFullYear() + parseInt(item.validade));
            const dataAlerta = new Date(dataVenc);
            dataAlerta.setMonth(dataAlerta.getMonth() - 3);
            const hoje = new Date();
            if (hoje >= dataVenc) statusData = 'vencido';
            else if (hoje >= dataAlerta) statusData = 'alerta';
        }
        let statusPassadas = 'normal';
        if (item.passadas_programadas && rowData.passadas) {
            const alvoTroca = rowData.passadas + item.passadas_programadas;
            const restantes = alvoTroca - (passadasAtuais || 0)
            if (restantes <= 0) statusPassadas = 'vencido';
            else if (restantes / item.passadas_programadas <= 0.1) statusPassadas = 'alerta';
        }
        if (statusData === 'vencido' || statusPassadas === 'vencido') return 'vencido';
        if (statusData === 'alerta'  || statusPassadas === 'alerta')  return 'alerta';
        return 'normal';
    };

    const fetchData = useCallback(() => {
        setIsLoading(true);
        api.get('sala').then((response) => {
            setColaboradores(response.data.colaboradores);
            setData(response.data.sala);
            setConfig(response.data.config);
            setTipos(response.data.tipos);
            setTurmas(response.data.turmas);
            setOleos(response.data.oleos);
            setHistoricoOleosGeral(response.data.historico_oleos);
            setHistoricoFitasGeral(response.data.historico_fitas);
            setHistoricoRodasGeral(response.data.historico_rodas);
            setIsLoading(false);
        }).catch((error) => { setIsLoading(false); showError(error); });

        api.get('fita').then(r => setListaFitas(r.data)).catch(() => setListaFitas([]));
        api.get('roda').then(r => setListaRodas(r.data)).catch(() => setListaRodas([]));
    }, []);

    const retrieveHistory = (tear) => {
        api.get(`tear-historico/${tear}/list`).then((response) => {
            const historico = response.data;
            setData(prev => {
                const copy = [...prev];
                const index = copy.findIndex(e => e.tear === tear);
                if (index !== -1) copy[index] = { ...copy[index], historico };
                return copy;
            });
            const oleosDoTear = historico.filter(h => h.manutencao_tipo_id === 10 || h.manutencao_tipo_id === 11);
            const fitasDoTear = historico.filter(h => h.manutencao_tipo_id === 24);
            const rodasDoTear = historico.filter(h => h.manutencao_tipo_id === 25);
            setHistoricoOleosGeral(prev => [...prev.filter(h => h.tear !== tear), ...oleosDoTear]);
            setHistoricoFitasGeral(prev => [...prev.filter(h => h.tear !== tear), ...fitasDoTear]);
            setHistoricoRodasGeral(prev => [...prev.filter(h => h.tear !== tear), ...rodasDoTear]);
        }).catch(() => {});
    };

    const handleEdit = (rowData) => {
        carregarFitas();
        carregarRodas();
        setFormHistory({
            id: rowData.id,
            colaborador_id: rowData.colaborador_id,
            data: new Date(String(rowData.data).replace(/-/g, "/")),
            descricao: rowData.descricao,
            tear: rowData.tear,
            manutencao_tipo_id: rowData.manutencao_tipo_id,
            turma_id: rowData.turma_id,
            oleo_id: rowData.oleo_id,
            fitas_id: rowData.fitas_id ?? null,
            rodas_id: rowData.rodas_id ?? null,
            passadas: rowData.passadas ?? null,
        });
        setIsEditing(true);
        setIsVisibleHistory(true);
    };

    const handleDelete = (rowData) => {
        confirmDialog({
            acceptClassName: "p-button-danger", acceptLabel: "Excluir",
            rejectClassName: "p-button-secondary", rejectLabel: "Cancelar",
            header: "Excluir",
            message: () => (
                <div>
                    <p>Você tem certeza que deseja excluir esse registro?</p>
                    <p>Tear: {rowData.tear}</p>
                    <p>Descrição: {rowData.descricao}</p>
                </div>
            ),
            accept: () => {
                setIsLoading(true);
                api.delete(`tear-historico/${rowData.id}/delete`).then((r) => {
                    retrieveHistory(rowData.tear);
                    setIsLoading(false);
                    showSuccess(r);
                }).catch((e) => { setIsLoading(false); showError(e); });
            }
        });
    };

    const handleReset = () => {
        setFormHistory({ ...initialFormHistoryState });
        setIsVisibleHistory(false);
    };

    const onHideHistory = () => {
        setIsEditing(false);
        setIsVisibleHistory(false);
        handleReset();
    };

    const handleSubmit = () => {
        setIsLoading(true);
        const form = { ...formHistory };
        const d = form.data;
        form.data = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;

        if (form.manutencao_tipo_id !== 10 && form.manutencao_tipo_id !== 11) form.oleo_id = null;
        if (form.oleo_id === "") form.oleo_id = null;
        if (form.manutencao_tipo_id !== 24) form.fitas_id = null;
        if (form.manutencao_tipo_id !== 25) form.rodas_id = null;
        if (form.manutencao_tipo_id !== 24 && form.manutencao_tipo_id !== 25) form.passadas = null;

        const req = (isEditing && form.id)
            ? api.put(`tear-historico/${form.id}/update`, form)
            : api.post('tear-historico', form);

        req.then((r) => {
            retrieveHistory(form.tear);
            setIsEditing(false);
            setIsLoading(false);
            showSuccess(r);
            handleReset();
        }).catch((e) => { setIsLoading(false); showError(e); });
    };

    const handleUpdate = (tear, grupo) => {
        setIsLoading(true);
        api.post('sala', { ...formData, tear: parseInt(tear), grupo: parseInt(grupo) }).then((r) => {
            fetchData();
            setIsLoading(false);
            setFormData({ ...initialState });
            setIsVisible(false);
            showSuccess(r);
        }).catch((e) => { setIsLoading(false); showError(e); });
    };

    const carregarOleos = () => {
        api.get('oleo').then(r => setListaOleos(r.data)).catch((e) => { showError(e); setListaOleos([]); });
    };

    const salvarOleo = () => {
        const req = oleo.id ? api.put(`oleo/${oleo.id}/update`, oleo) : api.post('oleo', oleo);
        req.then(() => { carregarOleos(); setIsVisibleOleoCE(false); showSuccess("Óleo salvo com sucesso!"); })
           .catch((e) => {
               if (e.response?.status === 422) showValidation(Object.values(e.response.data.errors)[0][0]);
               else showError(e);
           });
    };

    const deletarOleo = (rowData) => {
        confirmDialog({
            acceptClassName: "p-button-danger", acceptLabel: "Excluir",
            rejectClassName: "p-button-secondary", rejectLabel: "Cancelar",
            header: "Excluir Óleo",
            message: () => <div><p>Confirma exclusão?</p><p><strong>Óleo:</strong> {rowData.nome}</p></div>,
            accept: () => api.delete(`oleo/${rowData.id}/delete`).then(r => { carregarOleos(); showSuccess(r); }).catch(showError)
        });
    };

    const carregarFitas = () => {
        api.get('fita').then(r => setListaFitas(r.data)).catch((e) => { showError(e); setListaFitas([]); });
    };

    const salvarFita = () => {
        const req = fita.id ? api.put(`fita/${fita.id}/update`, fita) : api.post('fita', fita);
        req.then(() => { carregarFitas(); setIsVisibleFitaCE(false); showSuccess("Fita salva com sucesso!"); })
           .catch((e) => {
               if (e.response?.status === 422) showValidation(Object.values(e.response.data.errors)[0][0]);
               else showError(e);
           });
    };

    const deletarFita = (rowData) => {
        confirmDialog({
            acceptClassName: "p-button-danger", acceptLabel: "Excluir",
            rejectClassName: "p-button-secondary", rejectLabel: "Cancelar",
            header: "Excluir Fita",
            message: () => <div><p>Confirma exclusão?</p><p><strong>Nº Série:</strong> {rowData.nr_serie}</p></div>,
            accept: () => api.delete(`fita/${rowData.id}/delete`).then(r => { carregarFitas(); showSuccess(r); }).catch(showError)
        });
    };

    const carregarRodas = () => {
        api.get('roda').then(r => setListaRodas(r.data)).catch((e) => { showError(e); setListaRodas([]); });
    };

    const salvarRoda = () => {
        const req = roda.id ? api.put(`roda/${roda.id}/update`, roda) : api.post('roda', roda);
        req.then(() => { carregarRodas(); setIsVisibleRodaCE(false); showSuccess("Roda salva com sucesso!"); })
           .catch((e) => {
               if (e.response?.status === 422) showValidation(Object.values(e.response.data.errors)[0][0]);
               else showError(e);
           });
    };

    const deletarRoda = (rowData) => {
        confirmDialog({
            acceptClassName: "p-button-danger", acceptLabel: "Excluir",
            rejectClassName: "p-button-secondary", rejectLabel: "Cancelar",
            header: "Excluir Roda",
            message: () => <div><p>Confirma exclusão?</p><p><strong>Nº Série:</strong> {rowData.nr_serie}</p></div>,
            accept: () => api.delete(`roda/${rowData.id}/delete`).then(r => { carregarRodas(); showSuccess(r); }).catch(showError)
        });
    };

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    if (isLoading) {
        return <Loading />;
    }

    return (
        <div>
            <Menu />
            <Toast ref={toast} />

            <DialogTear
                isVisible={isVisible}
                setIsVisible={setIsVisible}
                formData={formData}
                setFormData={setFormData}
                config={config}
                toast={toast}
                handleUpdate={handleUpdate}
            />

            <DialogHistorico
                isVisibleHistory={isVisibleHistory}
                setIsVisibleHistory={setIsVisibleHistory}
                isEditing={isEditing}
                formHistory={formHistory}
                setFormHistory={setFormHistory}
                tipos={tipos}
                turmas={turmas}
                colaboradores={colaboradores}
                oleos={oleos}
                listaFitas={listaFitas}
                listaRodas={listaRodas}
                onHideHistory={onHideHistory}
                handleSubmit={handleSubmit}
            />

            <DialogOleo
                isVisibleOleo={isVisibleOleo}
                setIsVisibleOleo={setIsVisibleOleo}
                isVisibleOleoCE={isVisibleOleoCE}
                setIsVisibleOleoCE={setIsVisibleOleoCE}
                listaOleos={listaOleos}
                oleo={oleo}
                setOleo={setOleo}
                salvarOleo={salvarOleo}
                deletarOleo={deletarOleo}
            />

            <DialogFita
                isVisibleFita={isVisibleFita}
                setIsVisibleFita={setIsVisibleFita}
                isVisibleFitaCE={isVisibleFitaCE}
                setIsVisibleFitaCE={setIsVisibleFitaCE}
                listaFitas={listaFitas}
                fita={fita}
                setFita={setFita}
                salvarFita={salvarFita}
                deletarFita={deletarFita}
            />

            <DialogRoda
                isVisibleRoda={isVisibleRoda}
                setIsVisibleRoda={setIsVisibleRoda}
                isVisibleRodaCE={isVisibleRodaCE}
                setIsVisibleRodaCE={setIsVisibleRodaCE}
                listaRodas={listaRodas}
                roda={roda}
                setRoda={setRoda}
                salvarRoda={salvarRoda}
                deletarRoda={deletarRoda}
            />

            <div className="p-d-flex p-flex-row p-jc-end p-ai-center p-m-1">
                <Button
                    className="p-m-1"
                    icon="pi pi-plus"
                    onClick={() => setIsVisible(!isVisible)}
                    title="Clique para cadastrar ou atualizar um tear."
                />
                <Button
                    className="p-m-1"
                    label="Óleos"
                    onClick={() => { setIsVisibleOleo(!isVisibleOleo); carregarOleos(); }}
                />
                <Button
                    className="p-m-1"
                    label="Fitas"
                    onClick={() => { setIsVisibleFita(!isVisibleFita); carregarFitas(); }}
                />
                <Button
                    className="p-m-1"
                    label="Rodas"
                    onClick={() => { setIsVisibleRoda(!isVisibleRoda); carregarRodas(); }}
                />
                <Button
                    className="p-m-1"
                    icon="pi pi-file"
                    label="Relatório"
                    onClick={() => navigate('/manutencao/relatorio')}
                />
            </div>

            <Card className="p-m-1">
                <DataTable
                    dataKey="tear"
                    emptyMessage="Nenhum registro encontrado"
                    expandedRows={expandedRows}
                    filterDisplay="row"
                    onRowToggle={(e) => setExpandedRows(e.data)}
                    onRowExpand={(e) => retrieveHistory(e.data.tear)}
                    responsiveLayout="scroll"
                    rowExpansionTemplate={(rowData) => (
                        <TearExpansionTemplate
                            data={rowData}
                            tipos={tipos}
                            oleos={oleos}
                            listaFitas={listaFitas}
                            listaRodas={listaRodas}
                            verificarStatusOleo={verificarStatusOleo}
                            verificarStatusFitaRoda={verificarStatusFitaRoda}
                            handleEdit={handleEdit}
                            handleDelete={handleDelete}
                        />
                    )}
                    style={{ fontSize: 20, fontWeight: "bold" }}
                    value={data}
                >
                    <Column expander style={{ width: '3em' }} />
                    <Column
                        header="Tear"
                        field="tear"
                        filter
                        sortable
                        style={{ width: '15%' }}
                        body={(rowData) => {
                            let iconeAviso = null;
                            let itensVencidos = [];
                            let itensAlerta = [];
                            const ultimoOleo = historicoOleosGeral
                                .filter(h => h.tear === rowData.tear)
                                .sort((a, b) => b.id - a.id)[0];
                            if (ultimoOleo) {
                                const status = verificarStatusOleo(ultimoOleo);
                                if (status === 'vencido') itensVencidos.push("Óleo");
                                else if (status === 'alerta') itensAlerta.push("Óleo");
                            }
                            const ultimaFita = historicoFitasGeral
                                .filter(h => h.tear === rowData.tear)
                                .sort((a, b) => b.id - a.id)[0];
                            if (ultimaFita) {
                                const status = verificarStatusFitaRoda(ultimaFita, listaFitas, 'fitas_id', rowData.passadas_tear);
                                if (status === 'vencido') itensVencidos.push("Fita");
                                else if (status === 'alerta') itensAlerta.push("Fita");
                            }
                            const ultimaRoda = historicoRodasGeral
                                .filter(h => h.tear === rowData.tear)
                                .sort((a, b) => b.id - a.id)[0];
                            if (ultimaRoda) {
                                const status = verificarStatusFitaRoda(ultimaRoda, listaRodas, 'rodas_id', rowData.passadas_tear);
                                if (status === 'vencido') itensVencidos.push("Roda");
                                else if (status === 'alerta') itensAlerta.push("Roda");
                            }
                            if (itensVencidos.length > 0) {
                                const titulo = `Atenção: Vencido(s) neste Tear: ${itensVencidos.join(", ")}`;
                                iconeAviso = <i className="pi pi-exclamation-circle" style={{ color: '#c63737', marginLeft: '8px', fontSize: '1.2rem' }} title={titulo} />;
                            } else if (itensAlerta.length > 0) {
                                const titulo = `Aviso: Próximo do vencimento: ${itensAlerta.join(", ")}`;
                                iconeAviso = <i className="pi pi-exclamation-triangle" style={{ color: '#b59f00', marginLeft: '8px', fontSize: '1.2rem' }} title={titulo} />;
                            }
                            return (
                                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                    {iconeAviso}
                                    <span>{rowData.tear}</span>
                                </div>
                            );
                        }}
                    />
                    <Column header="Grupo" field="grupo" filter sortable style={{ width: '15%' }} />
                    <Column header="Modelo" field="modelo" />
                    <Column header="Serial" field="serial" />
                    <Column header="Data Aquisição" field="dataaquisicao" />
                    <Column header="Passadas" field="passadas_tear" />
                    <Column header="Pos X" field="pos_x" />
                    <Column header="Pos Y" field="pos_y" />
                    <Column
                        header="Ações"
                        body={(rowData) => (
                            <div>
                                <Button
                                    className="p-m-1 p-button-primary"
                                    icon="pi pi-pencil"
                                    title="Clique para editar o TEAR"
                                    onClick={() => {
                                        setIsVisible(true);
                                        const form = { ...rowData };
                                        if (rowData.dataaquisicao) {
                                            const [dia, mes, ano] = rowData.dataaquisicao.split('/');
                                            form.data_aquisicao = new Date(ano, mes - 1, dia);
                                        } else {
                                            form.data_aquisicao = null;
                                        }
                                        setFormData(form);
                                    }}
                                />
                                <Button
                                    className="p-m-1 p-button-success"
                                    icon="pi pi-plus"
                                    title="Clique para lançar uma alteração no TEAR"
                                    onClick={() => {
                                        carregarFitas();
                                        carregarRodas();
                                        setFormHistory({
                                            ...initialFormHistoryState,
                                            tear: rowData.tear,
                                            passadas: rowData.passadas_tear ?? null,
                                        });
                                        setIsVisibleHistory(true);
                                    }}
                                />
                            </div>
                        )}
                    />
                </DataTable>
            </Card>
        </div>
    );
}